/* eslint-disable react-hooks/exhaustive-deps */
import { Table, message } from 'antd';
import { useDispatch } from 'react-redux';
import { SCROLL } from 'datastake-daf/src/helpers/Table';
import { expandIcon } from 'datastake-daf/dist/components';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import Footer from '../../../update/merger/footer';
import { Style } from '../../../update/merger/style';
import Loading from '../../../../../components/Loading';
import { useCountry } from '../../../../../helpers/map';
import { actions } from '../../../../../store/reducers/admin';
import { isEmptyOrSpaces } from '../../../../../helpers/StringHelper';
import Confirmation from '../../../update/merger/components/confirmation';
import { useUserRoles } from '../../../../../components/Forms/users/config';
import { getColumns, getExpandTableColumns, getMappedInputs } from '../../config';
import { Animated } from '../../../../Modules/pme/screens/dashboard/widgets/tasks';
import { useApplications } from '../../../../../context/Applications';
import { getLocales } from '../../../../../components/Table/newTable';

function Merger({
  options = {},
  itemsToMerge = [],
  setItemsToMerge = () => { },
  close,
  t = (s) => s,
  columnConfig,
}) {
  const { applications } = useApplications();
  const loadingKeys = useRef({});
  const { countries } = useCountry();
  const [toggledKeys, setToggledKeys] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    users: itemsToMerge.reduce((prev, val) => prev + val.users?.length || 0, 0).toString(),
  });
  const userRoles = useUserRoles();
  const [requiredFields, setRequiredFields] = useState([]);
  const [areYouSureState, setAreYouSureState] = useState(false);

  const columns = useMemo(() =>
    getColumns({ t, ...columnConfig, view: 'default-merger' })
      .filter((v) => v.show), [t, columnConfig]);

  const expandedTableColumns = useMemo(() =>
    getExpandTableColumns({ t, ...columnConfig, view: 'default-merger', userRoles, applications })
      .filter((v) => v.show), [t, columnConfig, userRoles, applications]);

  const dispatch = useDispatch();

  const mappedInputs = useMemo(() => {
    const idOptions = itemsToMerge.map((i) => ({
      label: i.userId, value: i.userId,
    }));

    const emailOptions = itemsToMerge.map((i) => ({
      label: i.admin.email, value: i.admin.email,
    }));

    return getMappedInputs({ t, countries, idOptions, emailOptions, options, itemsToMerge, data })
  }, [t, countries, itemsToMerge, options, itemsToMerge, data]);

  const mergeIsDisabled = useMemo(() => {
    const nFF = [];

    requiredFields.forEach((f) => {
      if (!data[f]) {
        nFF.push(f);
      } else if (isEmptyOrSpaces(data[f])) {
        nFF.push(f);
      }
    });

    if (nFF.length === 0) {
      return false;
    } else {
      return true;
    }
  }, [requiredFields, data]);

  const firstItem = useMemo(() =>
    itemsToMerge[0] ? itemsToMerge[0] : null, [itemsToMerge]);

  const onSubmit = useCallback(() => {
    // TO-DO add call
    setLoading(true);
    const ids = itemsToMerge.map((i) => i.userId);

    dispatch(actions.mergeUser(
      'users',
      { data, ids },
      () => {
        setLoading(false);
        setItemsToMerge([]);
        close()
      },
      (err) => {
        setLoading(false);
        message.error(err.data && err.data.message ? err.data.message : (err.message || 'Something went wrong through merge'))
      },
    ))
  }, [data, itemsToMerge]);

  const onCheck = useCallback(() => {
    setLoading(true);
    setAreYouSureState(true);
    setLoading(false);
  }, [data, itemsToMerge]);

  return (
    <Style>
      {loading && <Loading />}
      <div className="default-padding daf-table-wrapper no-pagination">
        <Table
          locale={getLocales(t)}
          columns={columns}
          dataSource={itemsToMerge}
          pagination={false}
          scroll={{ x: SCROLL.x }}
          loading={loading}
          rowKey="id"
          expandIcon={(props) => expandIcon({
            ...props,
            arrows: true,
            toggledKeys,
            setToggledKeys,
            loadingKeys,
          })}
          expandable={{
            onExpandedRowsChange: (r) => {
              setExpandedRows(r);
            },
            expandedRowKeys: expandedRows,
            rowExpandable: (r) => !!r?.users?.length,
            expandedRowRender: (r) => {
              return (
                <Animated isActive={toggledKeys.includes(r.key)} maxHeight={SCROLL.y}>
                  <Table
                    locale={getLocales(t)}
                    pagination={false}
                    scroll={{ y: 110, x: SCROLL.x }}
                    className="lv-2-table"
                    columns={expandedTableColumns}
                    dataSource={r.users || []}
                    expandable
                    expandedRowRender={() => null}
                    doInject={false}
                    expandIcon={() => <button type="button" className="ant-table-row-expand-icon ant-table-row-expand-icon-spaced" aria-label="Expand row"></button>}
                  />
                </Animated>
              )
            }
          }}
          rowClassName={(rec) => expandedRows.includes(rec.key) ? 'expanded' : ''}
        />
      </div>

      <Footer
        renderLabels
        areYouSureState={areYouSureState}
        inputs={mappedInputs}
        firstItem={firstItem}
        data={data}
        setData={setData}
        requiredFields={requiredFields}
        setRequiredFields={setRequiredFields}
        t={t}
      />

      <Confirmation
        t={t}
        mergeIsDisabled={mergeIsDisabled}
        close={close}
        setAreYouSureState={setAreYouSureState}
        areYouSureState={areYouSureState}
        onSubmit={onSubmit}
        onCheck={onCheck}
      />
    </Style>
  );
}

export default Merger;
